/**
 * @props className (optional): 'mt20' (String)
 * @props label (optional): 'Background' (String)
 * @props background (required): { type, color, gradient, image, position, attachment, repeat, size, overlayColor } (Object)
 * @props onChange (required): (Function)
 * @props defaults (optional): { type, color, gradient, image, position, attachment, repeat, size, overlayColor } (Object)
 */

import { __ } from '@wordpress/i18n';
import { Button, PanelRow, Dropdown, __experimentalGradientPicker, GradientPicker, __experimentalAlignmentMatrixControl as AlignmentMatrixControl, SelectControl } from '@wordpress/components';
const Gradient = __experimentalGradientPicker || GradientPicker;

// Variables
import Title from './Title';
import BColor from './BColor';
import BtnGroup from './BtnGroup';
import { InlineDetailMediaUpload } from './MediaControl';
import { gradients } from './Helper/options';
const bgTypes = [
	{ label: 'Solid', value: 'solid' },
	{ label: 'Gradient', value: 'gradient' },
	{ label: 'Image', value: 'image' },
];
const attachments = [
	{ label: 'Initial', value: 'initial' },
	{ label: 'Scroll', value: 'scroll' },
	{ label: 'Fixed', value: 'fixed' },
	{ label: 'Local', value: 'local' },
];
const repeats = [
	{ label: 'No Repeat', value: 'no-repeat' },
	{ label: 'Repeat', value: 'repeat' },
	{ label: 'Repeat X', value: 'repeat-x' },
	{ label: 'Repeat Y', value: 'repeat-y' },
];
const sizes = [
	{ label: 'Cover', value: 'cover' },
	{ label: 'Auto', value: 'auto' },
	{ label: 'Contain', value: 'contain' },
];

const Background = props => {
	const { className = '', label = __('Background', 'bplugins'), value = {}, defaults = {}, onChange, isSolid = true, isGradient = true, isImage = true } = props;

	const defaultVal = { type: 'solid', color: '#000000b3', gradient: 'linear-gradient(135deg, #4527a4, #8344c5)', image: {}, position: 'center center', attachment: 'initial', repeat: 'no-repeat', size: 'cover', overlayColor: '#000000b3' }

	const getDefault = property => defaults?.[property] || defaultVal[property];
	const setDefault = property => onChange({ ...value, [property]: getDefault(property) });

	const getValue = property => value?.[property] || getDefault(property);
	const setValue = (property, val) => onChange({ ...value, [property]: val });
	const resetValue = property => <Button icon='image-rotate' className='bPlResetVal' onClick={() => setDefault(property)} />


	// useEffect(() => {
	// 	const allStyles = ('gradient' === getValue('type') && isGradient) ? `background: ${getValue('gradient')};` :
	// 		('image' === getValue('type') && isImage) ?
	// 			`background: url(${getValue('image')?.url});
	// 			background-position: ${getValue('position')};
	// 			background-size: ${getValue('size')};
	// 			background-repeat: ${getValue('repeat')};
	// 			background-color: ${getValue('overlayColor')};
	// 			background-blend-mode: overlay;` :
	// 			`background: ${getValue('color')};`;

	// 	const initObj = { type: getValue('type'), color: getValue('color'), gradient: getValue('gradient'), image: getValue('image'), position: getValue('position'), attachment: getValue('attachment'), repeat: getValue('repeat'), size: getValue('size'), overlayColor: getValue('overlayColor') }

	// 	onChange({ ...background, ...initObj, styles: allStyles.replace(/\s+/g, ' ').trim() });
	// }, [getValue('type'), getValue('color'), getValue('gradient'), getValue('image'), getValue('position'), getValue('attachment'), getValue('repeat'), getValue('size'), getValue('overlayColor')]);

	return <PanelRow className={`bPlDropdown ${className}`}>
		<Title className='mb5'>{label}</Title>

		<Dropdown className='bPlDropdownContainer' contentClassName='bPlDropdownPopover' position='bottom right'
			renderToggle={({ isOpen, onToggle }) => <Button icon='edit' onClick={onToggle} aria-expanded={isOpen} />}
			renderContent={() => <>
				{/* Type */}
				<PanelRow>
					<Title className=''>{__('Type:', 'bplugins')}</Title>
					<BtnGroup value={getValue('type')} onChange={val => setValue('type', val)} options={false === isSolid ? bgTypes.filter(b => b.value !== 'solid') : false === isGradient ? bgTypes.filter(b => b.value !== 'gradient') : false === isImage ? bgTypes.filter(b => b.value !== 'image') : bgTypes} />
				</PanelRow>

				{'solid' === getValue('type') && isSolid && <BColor className='mt20' label={__('Color:', 'bplugins')} value={getValue('color')} onChange={val => setValue('color', val)} defaultColor={getDefault('color')} />}

				{'gradient' === getValue('type') && isGradient && <Gradient className='mt20' value={getValue('gradient')} onChange={val => setValue('gradient', val)} gradients={gradients} />}

				{'image' === getValue('type') && isImage && <>
					<Title className='mb5'>{__('Image', 'bplugins')}</Title>
					<InlineDetailMediaUpload types={['image']} value={getValue('image')} onChange={val => setValue('image', val)} />

					<PanelRow>
						<Title className=''>{__('Position', 'bplugins')}</Title>
						<AlignmentMatrixControl value={getValue('position')} onChange={val => setValue('position', val)} />
						{value?.position && value?.position !== getDefault('position') && resetValue('position')}
					</PanelRow>

					<PanelRow>
						<Title className=''>{__('Attachment:', 'bplugins')}</Title>
						<SelectControl value={getValue('attachment')} onChange={val => setValue('attachment', val)} options={attachments} />
						{value?.attachments && value?.attachments !== getDefault('attachments') && resetValue('attachments')}
					</PanelRow>

					<PanelRow>
						<Title className=''>{__('Repeat:', 'bplugins')}</Title>
						<SelectControl value={getValue('repeat')} onChange={val => setValue('repeat', val)} options={repeats} />
						{value?.repeat && value?.repeat !== getDefault('repeat') && resetValue('repeat')}
					</PanelRow>

					<PanelRow>
						<Title className=''>{__('Size:', 'bplugins')}</Title>
						<SelectControl value={getValue('size')} onChange={val => setValue('size', val)} options={sizes} />
						{value?.size && value?.size !== getDefault('size') && resetValue('size')}
					</PanelRow>

					<BColor className='mt20' label={__('Overlay Color:', 'bplugins')} value={getValue('overlayColor')} onChange={val => setValue('overlayColor', val)} defaultColor={getDefault('overlayColor')} />
				</>}
			</>}
		/>
	</PanelRow>
};
export default Background;